import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/apiClient";

const TZ = (typeof Intl !== "undefined" && Intl.DateTimeFormat().resolvedOptions().timeZone) || "Europe/Lisbon";

// The REAL scheduled fixture between two clubs (venue, city, kick-off in the coach's timezone, referee).
// Single source of truth for venue across the app — pages auto-set Home/Away from it unless the coach overrides.
export const useNextFixture = (teamId, oppId, setVenue) => {
  const [fixture, setFixture] = useState(undefined);   // undefined = loading, null = none scheduled
  const touched = useRef(false);
  useEffect(() => {
    if (!teamId || !oppId || Number(teamId) === Number(oppId)) { setFixture(null); return; }
    let live = true;
    setFixture(undefined);
    touched.current = false;   // a new fixture resets any manual override
    api.get(`/fixture/next?team_id=${Number(teamId)}&opponent_id=${Number(oppId)}&tz=${encodeURIComponent(TZ)}`, { timeout: 12000 })
      .then((r) => {
        if (!live) return;
        const f = r.data?.fixture || null;
        setFixture(f);
        if (f && setVenue && !touched.current) setVenue(f.venue_for_team);
      })
      .catch(() => live && setFixture(null));
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamId, oppId]);
  const markTouched = () => { touched.current = true; };
  return { fixture, markTouched };
};
